import gql from 'graphql-tag';

const UPDATE_SYSTEM_ALERT = gql`
  mutation UpdateSystemAlert($id: ID!, $data: SystemAlertUpdateInput!) {
    updateSystemAlert(where: { id: $id }, data: $data) {
      id
      type
      message
      link
      linkText
      dismissible
      startDate
      endDate
      priority
      active
      updatedAt
    }
  }
`;

export default UPDATE_SYSTEM_ALERT;
